export default "__VITE_ASSET__qfIovdgd__"